export default __webpack_public_path__ + "static/media/ic_groups_active.58b2bd7f.svg";